<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>BOOK THREE</span></p>
<p class="part-center"><span>The Worst Is Yet to Come</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part03.vue?23f470f4